<script lang="ts" setup>
  import { OrdersManagementListView } from '@/views/shop/orders-management'

  import { useOrdersManagementPage } from './model/useOrdersManagementPage'

  definePage({
    meta: {
      layout: 'baseNew',
      shopManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: computed(() => t('orders_management_title')),
  })

  const { actions, dateFormat, dateRange, filters, list, modals, pagination } = useOrdersManagementPage()
</script>

<template>
  <OrdersManagementListView
    :actions="actions"
    :date-format="dateFormat"
    :date-range="dateRange"
    :filters="filters"
    :list="list"
    :modals="modals"
    :pagination="pagination"
  />
</template>
